import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Checkbox } from "primereact/checkbox";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../../context/AlertContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Link, Redirect } from "react-router-dom";
import Spinner from "../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../../assets/css/PrimeGrid.css";
import "../../../assets/css/CierreDialog.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import hcOffcanvasNav from "hc-offcanvas-nav";
import $ from "jquery";
import { saveAs } from "file-saver";
import { Navigate, useNavigate } from "react-router-dom";
import Barra from "../Barra";
import { ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { getBrand, createBrandTheme } from "../../../theme/brand";
import PantallaHeader from "../common/PantallaHeader";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { SelectButton } from "primereact/selectbutton";

export default function Tareas(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const exportColumns = [
    { title: "ID", dataKey: "id" },
    { title: "Fecha", dataKey: "fecha" },
    { title: "Descripción", dataKey: "descripcion" },
    { title: "Email", dataKey: "email" },
  ];

  const [tarea, guardarTarea] = useState(null);
  const [visible, setVisible] = useState(false);
  const options = ["Pendientes", "Enviadas"];
  const [value, setValue] = useState(options[0]);
  const toast = useRef(null);
  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    configuracion,
    tareas,
    obtenerTareas,
    obtenerAcceso,
    actualizarTarea,
    agregarTarea,
    eliminarTarea,
  } = configuracionContext;

  const theme = createBrandTheme(getBrand(configuracion));

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "Tareas" });
    }
    obtenerTareas({estado: value, usuarioId: state.usuario.id});
  }, [state.id]);

  setTimeout(() => {
    if (statusAcceso === 400) {
      accesoDenegado();
    }
  }, 3000);

  const editClick = () => {
    if (selectedRow) {
      guardarTarea(selectedRow);
      setVisible(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar una tarea.",
        life: 3000,
      });
    }
  };

  const eliminarClick = () => {
    if (!selectedRow) {
      toast.current.show({
        severity: "info",
        summary: "Eliminar",
        detail: "Debe seleccionar una tarea.",
        life: 3000,
      });
      return;
    }

    confirmDialog({
      message: "Confirma eliminar tarea " + selectedRow.descripcion + " ?",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => acceptFunc(),
    });
  };

  const acceptFunc = (id) => {
    eliminarTarea({ id: selectedRow.id });
    onHide();
    setSelectedRow(null);
    setTimeout(() => {
      obtenerTareas({estado: value});
    }, 2000);
    //exitClick()
  };

  const addClick = (e) => {
    //navigate(`/tarea/0`);
    setVisible(true);
    setSelectedRow(null);
    guardarTarea({
      pendiente: true,
    });
  };

  const exitClick = (e) => {
    navigate(`/`);
  };

  const onHide = (e) => {
    setVisible(false);
  };

  const aceptarClick = (e) => {
    e.preventDefault();
    //Validar

    if (
      !tarea ||
      tarea.fecha === undefined ||
      tarea.fecha === null ||
      tarea.fecha.trim() === ""
    ) {
      mensajeAlerta("Tareas", "Fecha es necesaria !.", "error");
      return;
    }

    if (
      !tarea ||
      tarea.descripcion === undefined ||
      tarea.descripcion === null ||
      tarea.descripcion.trim() === ""
    ) {
      mensajeAlerta("Tareas", "La descripción es necesaria !.", "error");
      return;
    }

    if (
      !tarea ||
      tarea.email === undefined ||
      tarea.email === null ||
      tarea.email.trim() === ""
    ) {
      mensajeAlerta("Tareas", "El email es necesario !.", "error");
      return;
    }

    // Llamar al context
    if (selectedRow) {
      actualizarTarea({ tarea});
    } else {
      agregarTarea({ tarea, usuarioId: state.usuario.id });
    }
    onHide();
    setSelectedRow(null);
    setTimeout(() => {
      obtenerTareas({estado: value, usuarioId: state.usuario.id});
    }, 2000);
    //exitClick();
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Accesos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };

  const idTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">ID</span>
        {rowData.id}
      </Fragment>
    );
  };

  const fechaTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Fecha</span>
        {formatDateTime(rowData.fecha)}
      </Fragment>
    );
  };

  const descripcionTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Descripción</span>
        {rowData.descripcion}
      </Fragment>
    );
  };

  const emailTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Email</span>
        {rowData.email}
      </Fragment>
    );
  };

  const habilitadoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Habilitado</span>
        <Checkbox checked={rowData.habilitado}></Checkbox>
      </Fragment>
    );
  };

  function formatDateTime(dateString) {
    var allDate = dateString.replace("T", " ");
    allDate = allDate.replace(".", " ");
    allDate = allDate.split(" ");
    var thisDate = allDate[0].split("-");
    var thisTime = allDate[1].split(":");
    var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");
    var newTime = [thisTime[0], thisTime[1]].join(":");
    return newDate + " " + newTime;
  }

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.setFontSize(12);
        doc.text("Listado de Tareas " + value, 60, 8);
        doc.autoTable(exportColumns, tareas);
        //doc.save("tareas.pdf");
        window.open(doc.output("bloburl"));
      });
    });
  };

  {
    /*
  const prueba = () => {
    const data = {
      email: "martin.leda@medic.com.ar",
      token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9",
      template: "NuevoMensaje",
    };

    axios
      .post("https://api.libresalud.com.ar/api/servicios/sendemail", {
        email: "martin.leda@medic.com.ar",
        token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9",
        template: "NuevoMensaje",
      })
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function () {});
  };

*/
  }

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(tareas);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "tareas");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
      );
    });
  };

  const header = (
    <Fragment>
                <Grid container spacing={3} style={{ marginTop: "1vw" }}>
        <Button
          type="button"
          icon="pi pi-file-excel"
          onClick={exportExcel}
          className="p-button-success p-mr-2"
          data-pr-tooltip="XLS"
        />
        <Button
          type="button"
          icon="pi pi-file-pdf"
          onClick={exportPdf}
          className="p-button-warning p-mr-2"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
        />
        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Tag value="Tareas"></Tag>
      <SelectButton
        value={value}
        onChange={(e) => {
          setValue(e.value)
          obtenerTareas({estado: e.value})
        }}
        options={options}
        style ={{marginLeft: "5em"}}
      />
      </Grid>
    </Fragment>
  );

  const renderHeader = () => {
    return (
      <div>
        <Tag value="Tarea"></Tag>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarClick}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHide}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  //console.log(tareas);

  return (
    <Fragment>
      <Barra />
      <Toast ref={toast} />
      <ConfirmDialog />
      {statusAcceso === 0 || statusAcceso === 400 ? <Spinner /> : null}
      {statusAcceso === 200 ? (
        <Fragment>
          {tareas ? (
            <ThemeProvider theme={theme}>
              <Box sx={{ px: { xs: 1, sm: 2 }, pb: 3 }}>
                <PantallaHeader
                  icono={<ChecklistOutlinedIcon />}
                  titulo="Tareas"
                  count={tareas ? tareas.length : null}
                  onBuscar={(v) => setGlobalFilter(v)}
                  extra={
                    <SelectButton
                      value={value}
                      onChange={(e) => {
                        if (!e.value) return;
                        setValue(e.value);
                        obtenerTareas({ estado: e.value });
                      }}
                      options={options}
                    />
                  }
                  acciones={[
                    {
                      label: "Nuevo",
                      variant: "contained",
                      icon: <AddIcon />,
                      onClick: addClick,
                    },
                    {
                      label: "Editar",
                      icon: <EditIcon />,
                      disabled: value === "Enviadas",
                      onClick: editClick,
                    },
                    {
                      label: "Eliminar",
                      color: "error",
                      icon: <DeleteOutlineIcon />,
                      disabled: value === "Enviadas",
                      onClick: eliminarClick,
                    },
                    {
                      label: "Cerrar",
                      variant: "text",
                      color: "inherit",
                      icon: <CloseIcon />,
                      onClick: exitClick,
                    },
                  ]}
                />
                <Paper
                  elevation={0}
                  sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    "& .p-datatable-wrapper": { overflowX: "auto" },
                  }}
                >
                    <DataTable
                      value={tareas}
                      selection={selectedRow}
                      onSelectionChange={(e) => setSelectedRow(e.value)}
                      selectionMode="single"
                      dataKey="id"
                      className="p-datatable-sm p-datatable-striped p-datatable-responsive-demo mito-grid"
                      style={{ fontSize: "small" }}
                      globalFilter={globalFilter}
                      emptyMessage="No hay datos."
                      paginator
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                      rows={10}
                      rowsPerPageOptions={[10, 20, 50]}
                      //paginatorLeft={paginatorLeft}
                      //paginatorRight={paginatorRight}
                    >
                      <Column
                        field="id"
                        header="ID"
                        //body={idTemplate}
                        //sortable
                        styke={{ display: "none" }}
                      ></Column>
                      <Column
                        field="fecha"
                        header="Fecha"
                        body={fechaTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="descripcion"
                        header="Descripción"
                        body={descripcionTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="email"
                        header="Email"
                        body={emailTemplate}
                        sortable
                      ></Column>
                    </DataTable>
                </Paper>

              <Dialog
                className="cierre-dialog"
                header={renderHeader()}
                visible={visible}
                closable={false}
                footer={renderFooter()}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "50vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid container spacing={3} style={{ marginTop: "1vw" }}>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="fecha"
                      label="Fecha"
                      type="datetime-local"
                      fullWidth
                      variant="standard"
                      value={tarea?.fecha || ""}
                      defaultValue={
                        selectedRow &&
                        selectedRow.fecha !== "" &&
                        selectedRow.fecha !== null
                          ? selectedRow.fecha
                          : null
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 3600, // solo horas
                      }}
                      onChange={(e) => {
                        let valor = e.target.value; // ej: 2026-04-19T11:23

                        if (valor) {
                          const [fecha, hora] = valor.split("T");
                          const horaSolo = hora.split(":")[0];

                          guardarTarea({
                            ...tarea,
                            fecha: `${fecha}T${horaSolo}:00`,
                          });
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={11}>
                    <TextField
                      value={
                        tarea && tarea.descripcion ? tarea.descripcion : null
                      }
                      required
                      id="descripcion"
                      label="Descripción"
                      fullWidth
                      variant="standard"
                      onChange={(e) =>
                        guardarTarea({
                          ...tarea,
                          descripcion: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={11}>
                    <TextField
                      value={tarea && tarea.email ? tarea.email : null}
                      required
                      id="email"
                      label="Email"
                      fullWidth
                      variant="standard"
                      onChange={(e) =>
                        guardarTarea({
                          ...tarea,
                          email: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
              </Dialog>
              </Box>
            </ThemeProvider>
          ) : (
            <Spinner />
          )}
          <Grid item xs={12} sm={12}></Grid>
        </Fragment>
      ) : null}
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
